module.exports = __webpack_public_path__ + "media/wyposazenie/komfort-9f4e1f98.png";